module.exports = __webpack_public_path__ + "img/add-more-member-licence.28ac940d.webp";